export default __webpack_public_path__ + "static/media/favorite.fb6d5bbb.svg";